<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{mostRecentExecuted.mobileEndPoint ? 'Mobile' : 'Desktop'}} Instruction Details</h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" id="modal-body">
  <div *ngIf="mobileInstruction.screenshotFileId || mobileInstruction.screenshotFileName" class="row configDetails ">
      <div class="col-2 strong">SCREENSHOT :</div>
      <div class="col-3">
        <a ngbTooltip="Click here to download the screenshot" (click)="downloadFile(mobileInstruction.screenshotFileId, mobileInstruction.screenshotFileName)">{{mobileInstruction.screenshotFileName}}</a>
      </div>
  </div>
  <hr *ngIf="mobileInstruction.screenshotFileId">
  <div *ngIf="mobileInstruction.errorMessage" class="row">
      <div class="col-2 strong">
          ERROR MESSAGE :
      </div>
      <div class="col" style="color: red;">{{mobileInstruction.errorMessage}}</div>
  </div>
  <hr *ngIf="mobileInstruction.errorMessage">
  <div *ngIf="mobileInstruction.mobileDataExtractor" class="row configDetails">
    <div class="col-2 strong">EXTRACTOR</div>
    <div class="col" style="display: block;">
      <div> <strong>Key :</strong> {{mobileInstruction.mobileDataExtractor.extractorDisplayValue}}</div>
      <div style="word-break: break-all;"> <strong>Value :</strong> {{mobileInstruction.mobileDataExtractor.extractedValue}} </div>
    </div>
  </div>
  <hr *ngIf="mobileInstruction.mobileDataExtractor">
  <div *ngIf="mobileInstruction.inputFileId || mobileInstruction.inputFileName" class="row configDetails">
    <div class="col-2 strong">INPUT FILE:</div>
    <div class="col">
        <a ngbTooltip="Click to download the file" (click)="downloadFile(mobileInstruction.inputFileId, mobileInstruction.inputFileName)">{{mobileInstruction.inputFileName}}</a>
    </div>
</div>
<hr *ngIf="mobileInstruction.inputFileId">
<div *ngIf="mobileInstruction.outputFileId || mobileInstruction.outputFileName" class="row configDetails">
      <div class="col-2 strong">OUTPUT FILE:</div>
      <div class="col">
          <a ngbTooltip="Click to download the file" (click)="downloadFile(mobileInstruction.outputFileId, mobileInstruction.outputFileName)">{{mobileInstruction.outputFileName}}</a>
      </div>
  </div>
  <hr *ngIf="mobileInstruction.outputFileId">
  <div *ngIf="mobileInstruction.mobileInstructionActionTypes" class="row configDetails">
    <div class="col-2">
      <div class="strong text-uppercase">Retry Count :</div> {{mobileInstruction.retryCount}}
    </div>
    <div class="col-2">
      <div class="strong text-uppercase">Jump Count :</div> {{mobileInstruction.jumpCount}}
    </div>
    <div class="col-8">
      <div class="strong text-uppercase">Actions :</div>
      <div style="word-wrap: break-word;">{{mobileInstruction.mobileInstructionActionTypes}}</div>
    </div>
  </div>
  <hr *ngIf="mobileInstruction.mobileInstructionActionTypes">
  <div *ngIf="mobileInstruction.postOperationConditions" class="configDetails">
      <div class="row" style="margin-bottom: 5px;">
          <div class="col-2 strong">CONDITIONS:</div> <br>
      </div>
      <div class="row">
          <div class="col">
              <table class="table table-sm table-hover relay-word-wrap" style="table-layout:fixed">
                  <thead class="table-active">
                      <tr>
                          <th width="15%">Type</th>
                          <th width="30%">Actual</th>
                          <th width="15%">Expected</th>
                          <th width="15%">Threshold</th>
                          <th width="15%">Output file</th>
                          <th width="10%">Status</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr *ngFor="let postOperationCondition of mobileInstruction.postOperationConditions">
                          <td>
                              {{ postOperationCondition.conditionSequence }}. {{ postOperationCondition.condition }}
                          </td>
                          <td>
                              <div *ngIf="postOperationCondition.actualSide.testDataType === 'RELAY_FILE' || postOperationCondition.actualSide.testDataType === 'MOBILE_FILE'">
                                <a ngbTooltip="Click to download the file"
                                  (click)="downloadFile(postOperationCondition.actualSide.fileObjectId, postOperationCondition.actualSide.fileName)">{{postOperationCondition.actualSide.fileName}}</a>
                              </div>
                              <div *ngIf="postOperationCondition.actualSide.testDataType === 'INSTRUCTION_STATUS'
                                              || postOperationCondition.actualSide.testDataType === 'EXTRACTOR'">
                                {{postOperationCondition.actualSide.value}}
                              </div>
                              <div *ngIf="postOperationCondition.actualSide.testDataType === 'STRING'">
                                '{{postOperationCondition.actualSide.value}}'
                              </div>
                          </td>
                          <td>
                              <div *ngIf="postOperationCondition.expectedSide.testDataType === 'RELAY_FILE' || postOperationCondition.expectedSide.testDataType === 'MOBILE_FILE'">
                                <a ngbTooltip="Click to download the file"
                                  (click)="downloadFile(postOperationCondition.expectedSide.fileObjectId, postOperationCondition.expectedSide.fileName)">{{postOperationCondition.expectedSide.fileName}}</a>
                              </div>
                              <div *ngIf="postOperationCondition.expectedSide.testDataType === 'INSTRUCTION_STATUS'
                                              || postOperationCondition.expectedSide.testDataType === 'EXTRACTOR'">
                                {{postOperationCondition.expectedSide.value}}
                              </div>
                              <div *ngIf="postOperationCondition.expectedSide.testDataType === 'STRING'">
                                '{{postOperationCondition.expectedSide.value}}'
                              </div>
                          </td>
                          <td>
                              <div>
                                  <div *ngIf="postOperationCondition.condition === 'IMAGE_COMPARE' || postOperationCondition.condition === 'IMAGE_CONTAINS'">{{ postOperationCondition.actualThreshold }} >= {{ postOperationCondition.expectedThreshold}}</div>
                                  <div *ngIf="postOperationCondition.condition !== 'IMAGE_COMPARE' && postOperationCondition.condition !== 'IMAGE_CONTAINS'">N/A</div>
                              </div>
                          </td>
                          <td>
                            <div>
                              <div *ngIf="postOperationCondition.condition === 'IMAGE_COMPARE' || postOperationCondition.condition === 'IMAGE_CONTAINS'">
                                <a ngbTooltip="Click to download the file" (click)="downloadFile(postOperationCondition.outputFileId, postOperationCondition.outPutFileName)">{{postOperationCondition.outPutFileName}}</a>
                              </div>
                              <div *ngIf="postOperationCondition.condition !== 'IMAGE_COMPARE' && postOperationCondition.condition !== 'IMAGE_CONTAINS'">N/A</div>
                            </div>
                          <td>
                            <span class="badge" [ngClass]="{'badge-secondary': postOperationCondition.status === 'PENDING', 'badge-success': postOperationCondition.status === 'PASSED', 'badge-danger': postOperationCondition.status === 'FAILED', 'badge-info': postOperationCondition.status === 'IN_PROGRESS'}" ngbTooltip="{{postOperationCondition.errorMessage}}">
                              {{postOperationCondition.status}}
                            </span>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
      </div>
  </div>
</div>